// extracted by mini-css-extract-plugin
module.exports =  {"title":"_93444fe79c--title--mgUpm","link":"_93444fe79c--link--lKHhX"};